'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

require('imageviewer');

var _themeVariants = require('@shopify/theme-variants');

var _themeVariants2 = _interopRequireDefault(_themeVariants);

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

var selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productImageWrapper: '[data-product-image-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]'
};

var cssClasses = {
  activeThumbnail: 'active-thumbnail',
  hide: 'hide'
};

var keyboardKeys = {
  ENTER: 13
};

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {

    this.$container = (0, _jquery2.default)(this.container);
    this.namespace = '.' + this.id;
    this.$productImages = this.$container.find('.ProductImages');
    console.log('product loaded');
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!(0, _jquery2.default)(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse((0, _jquery2.default)(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new _themeVariants2.default(options);
    this.$featuredImage = (0, _jquery2.default)(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if ((0, _jquery2.default)('[data-add-to-cart]').length > 0) {
      (0, _jquery2.default)('[data-add-to-cart]').on('click', function (e) {
        e.preventDefault();
        console.log('add to cart');
        var $product = (0, _jquery2.default)(this).closest('form');
        var selected_id = Number($product.find('[data-product-select]').val()),
            qty = 1;

        var $button = (0, _jquery2.default)(this);

        cart.addItem(selected_id, { quantity: qty }).then(function (item) {
          cart.getState().then(function (state) {
            console.log(state);
            (0, _jquery2.default)('.cart-count').text(state.item_count);
            (0, _jquery2.default)('.cart-counter').show();
            (0, _jquery2.default)('.cart-counter').parent().addClass('active blue');
          });
          console.log('An item with a quantity of ' + qty + ' was added to your cart:', item);

          //flip text
          $product.find('[data-add-to-cart-text]').text('added').css({ 'color': 'black' });
          $product.find('[data-add-to-cart-text]').parent().css('pointer-events', 'none');

          setTimeout(function () {
            $button.find('[data-add-to-cart-text]').text($button.attr('data-cta')).css({ 'color': '' });
            $button.find('[data-add-to-cart-text]').parent().css('pointer-events', 'auto');
          }, 2000);
        });
      });
    }

    var $productContainer = (0, _jquery2.default)('.barba-container:last .ProductImages');

    var curr_image = $productContainer.find('li.active').index(),
        total_images = $productContainer.find('li').length - 1;

    (0, _jquery2.default)('.product-images li').on('click', function (e) {
      if (e.clientX < (0, _jquery2.default)(this).width() / 2) {
        prevImage();
      } else {
        nextImage();
      }
    });

    (0, _jquery2.default)("body").off('keydown').on('keydown', function (e) {
      if (e.keyCode == 37) {
        // left
        prevImage();
      } else if (e.keyCode == 39) {
        // right
        nextImage();
      }
    });

    function prevImage() {
      curr_image = curr_image > 0 ? curr_image - 1 : total_images;
      (0, _jquery2.default)('.product-images li').removeClass('active');
      (0, _jquery2.default)('.product-images li').eq(curr_image).addClass('active');
      (0, _jquery2.default)('.current-image').text(curr_image + 1);
    }
    function nextImage() {
      curr_image = curr_image < total_images ? curr_image + 1 : 0;
      (0, _jquery2.default)('.product-images li').removeClass('active');
      (0, _jquery2.default)('.product-images li').eq(curr_image).addClass('active');
      (0, _jquery2.default)('.current-image').text(curr_image + 1);
    }

    var viewers = [];

    function addViewer() {

      if ((0, _jquery2.default)(window).width() <= 733) {
        if (viewers.length > 0) {
          return true;
        } else {
          (0, _jquery2.default)('.ProductImages li').each(function () {
            var $image = (0, _jquery2.default)(this);
            var $viewer = $image.viewer({
              "navbar": false,
              "title": false,
              "tooltip": false,
              "toolbar": false,
              "rotatable": false,
              "transition": false,
              "minZoomRatio": .5,
              "url": function url() {
                return (0, _jquery2.default)($image[0]).attr('data-zoom');
              },
              viewed: function viewed() {
                $image.viewer('zoomTo', .5);
              }
            });
            $image.addClass('li-viewer');
            viewers.push($viewer);
          });
        }
      } else {
        if (viewers.length > 0) {
          for (var i = 0; i < viewers.length; i++) {
            viewers[i].viewer('destroy');
          }

          viewers = [];
        }
      }
    }

    //addViewer();

    (0, _jquery2.default)(window).on('resize', function () {
      //addViewer();
    });

    return true;

    var settings = {
      slidesToShow: 1,
      arrows: false,
      dots: false,
      speed: 0
    };

    var $pi = this.$productImages;
    var $slideshow = '';
    var currSlide = 1;
    var $productContainer = (0, _jquery2.default)('.barba-container:last .ProductImages');
    var totalImages = $productContainer.find('li').length;
    var $total_images = (0, _jquery2.default)('.total-images');
    var $curr_image = (0, _jquery2.default)('.barba-container:last .current-image');
    (0, _jquery2.default)('.siema-slideshow').removeClass('siema-slideshow');

    function makeSlideshow() {
      $productContainer.addClass('siema-slideshow');
      if ((0, _jquery2.default)('.siema-slideshow').length > 0) {
        var _slideshowPrev = function _slideshowPrev() {
          currSlide--;
          if (currSlide <= 0) currSlide = totalImages;
          //$curr_image.text(currSlide);
          $slideshow.prev();
        };

        var _slideshowNext = function _slideshowNext() {
          currSlide++;
          if (currSlide == totalImages + 1) currSlide = 1;
          //$curr_image.text(currSlide);
          $slideshow.next();
        };

        var printSlideIndex = function printSlideIndex() {
          //console.log('current slide + ' + $slideshow.currentSlide)
          if ($slideshow.currentSlide != undefined) {
            $curr_image.text($slideshow.currentSlide + 1);
          } else {
            $curr_image.text(1);
          }
        };

        $slideshow = new _siema2.default({
          selector: '.siema-slideshow',
          duration: 0,
          easing: 'linear',
          perPage: 1,
          startIndex: 0,
          draggable: false,
          multipleDrag: false,
          threshold: 20,
          loop: true,
          rtl: false,
          onInit: printSlideIndex,
          onChange: printSlideIndex
        });
        $slideshow.currentSlide = 0;
        (0, _jquery2.default)('.barba-container:last .ProductImages').off('click').on('click', function (e) {
          if (e.clientX > (0, _jquery2.default)('.ProductImages').width() / 2) {
            _slideshowNext();
          } else {
            _slideshowPrev();
          }
        });

        (0, _jquery2.default)("body").off('keydown').on('keydown', function (e) {
          if (e.keyCode == 37) {
            // left
            _slideshowPrev();
          } else if (e.keyCode == 39) {
            // right
            _slideshowNext();
          }
        });
      }
    }

    manageSlideshows();

    (0, _jquery2.default)(document).on('lazyloaded', function (e) {
      console.log('lazyloaded resize handler');
      //$slideshow.resizeHandler();
      (0, _jquery2.default)(window).trigger('resize');
    });

    function manageSlideshows() {
      if ((0, _jquery2.default)(window).width() > 733 && !$productContainer.hasClass('siema-slideshow')) {
        console.log('make slideshow');
        makeSlideshow();
      }

      if ((0, _jquery2.default)(window).width() <= 733) {
        if ($productContainer.hasClass('siema-slideshow')) {
          $slideshow.destroy(true);
          $productContainer.removeClass('siema-slideshow');
        }
        (0, _jquery2.default)('.ProductImages').css('height', '');
      }

      //addViewer();
    }

    (0, _jquery2.default)(window).on('resize', function () {
      manageSlideshows();
    });

    var viewers = [];

    function addViewer() {
      if ((0, _jquery2.default)(window).width() <= 733) {
        if (viewers.length > 0) {
          return true;
        } else {
          (0, _jquery2.default)('.ProductImages li').each(function () {
            var $image = (0, _jquery2.default)(this);
            var $viewer = $image.viewer({
              "navbar": false,
              "title": false,
              "tooltip": false,
              "toolbar": false,
              "rotatable": false,
              "transition": false,
              "minZoomRatio": .5,
              "url": function url() {
                return (0, _jquery2.default)($image[0]).attr('data-zoom');
              },
              viewed: function viewed() {
                $image.viewer('zoomTo', .5);
              }
            });
            $image.addClass('li-viewer');
            viewers.push($viewer);
          });
        }
      } else {
        if (viewers.length > 0) {
          for (var i = 0; i < viewers.length; i++) {
            viewers[i].viewer('destroy');
          }

          viewers = [];
        }
      }
    }

    addViewer();

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateImages.bind(this));
    }

    this.initImageSwitch();
  },
  initImageSwitch: function initImageSwitch() {
    var _this = this;

    var $productThumbs = (0, _jquery2.default)(selectors.productThumbs, this.$container);

    if (!$productThumbs.length) {
      return;
    }

    $productThumbs.on('click', function (evt) {
      evt.preventDefault();
      var imageId = (0, _jquery2.default)(evt.currentTarget).data('thumbnail-id');
      _this.switchImage(imageId);
      _this.setActiveThumbnail(imageId);
    }).on('keyup', this.handleImageFocus.bind(this));
  },
  handleImageFocus: function handleImageFocus(evt) {
    if (evt.keyCode !== keyboardKeys.ENTER) {
      return;
    }

    this.$featuredImage.filter(':visible').focus();
  },
  setActiveThumbnail: function setActiveThumbnail(imageId) {
    var newImageId = imageId;

    // If "imageId" is not defined in the function parameter, find it by the current product image
    if (typeof newImageId === 'undefined') {
      newImageId = (0, _jquery2.default)(selectors.productImageWrapper + ':not(\'.' + cssClasses.hide + '\')').data('image-id');
    }

    var $thumbnail = (0, _jquery2.default)(selectors.productThumbs + '[data-thumbnail-id=\'' + newImageId + '\']');

    (0, _jquery2.default)(selectors.productThumbs).removeClass(cssClasses.activeThumbnail).removeAttr('aria-current');

    $thumbnail.addClass(cssClasses.activeThumbnail);
    $thumbnail.attr('aria-current', true);
  },
  switchImage: function switchImage(imageId) {
    var $newImage = (0, _jquery2.default)(selectors.productImageWrapper + '[data-image-id=\'' + imageId + '\']', this.$container);
    var $otherImages = (0, _jquery2.default)(selectors.productImageWrapper + ':not([data-image-id=\'' + imageId + '\'])', this.$container);
    $newImage.removeClass(cssClasses.hide);
    $otherImages.addClass(cssClasses.hide);
  },


  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState: function updateAddToCartState(evt) {
    var variant = evt.variant;

    if (variant) {
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).removeClass(cssClasses.hide);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
      (0, _jquery2.default)(selectors.priceWrapper, this.$container).addClass(cssClasses.hide);
      return;
    }

    if (variant.available) {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', false);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.$container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
    }
  },
  updateImages: function updateImages(evt) {
    var variant = evt.variant;
    var imageId = variant.featured_image.id;

    this.switchImage(imageId);
    this.setActiveThumbnail(imageId);
  },


  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices: function updateProductPrices(evt) {
    var variant = evt.variant;
    var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, this.$container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

    (0, _jquery2.default)(selectors.productPrice, this.$container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass(cssClasses.hide);
    } else {
      $comparePrice.html('');
      $compareEls.addClass(cssClasses.hide);
    }
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    this.$container.off(this.namespace);
  }
});